import { useMemo } from 'react';
import { connect } from 'react-redux';
import { DataGrid } from '@mui/x-data-grid';
import { Autocomplete, TextField } from '@mui/material';
import * as Actions from '../../actions/actions';

const RouteDetailsGridPanel = ({ allRouteDetailsData, filters, filterOptions, ...props }) => {

    const filteredData = useMemo(() => {
        if (!allRouteDetailsData || allRouteDetailsData.length === 0) return [];
        if (filters.route && filters.route.id) {
            return allRouteDetailsData.filter(row => row.route_system_id === filters.route.id);
        }
        return allRouteDetailsData;
    }, [allRouteDetailsData, filters.route]);

    const columns = [
        { field: 'local_route', headerName: 'Route', width: 120 },
        { field: 'dock_door', headerName: 'Door', width: 120 },
        { field: 'stop_number', headerName: 'Stop #', width: 100, type: 'number' },
        { field: 'store_name', headerName: 'Store Name', width: 180 },
        { field: 'store_number', headerName: 'Store #', width: 120 },
        { field: 'pallet_number', headerName: 'Pallet #', width: 120 },
        { field: 'rfid', headerName: 'RFID', width: 180 },
        { field: 'status', headerName: 'Status', width: 120 },
        { field: 'loaded_stop_number', headerName: 'Loaded Stop #', width: 140, type: 'number' },
        { field: 'operation_time_local', headerName: 'Scan Time', width: 200 },
        { field: 'is_out_of_order', headerName: 'Out of Order', width: 130, type: 'boolean' },
        { field: 'is_wrong_door', headerName: 'Wrong Door', width: 130, type: 'boolean' },
        { field: 'is_wrong_route', headerName: 'Wrong Route', width: 130, type: 'boolean' },
        { field: 'is_return', headerName: 'Return', width: 100, type: 'boolean' }
    ];

    const handleRouteFilterChange = (_event, value) => {
        props.updateFilters('route', value);
    };

    return (
        <div className="dashboardData-panel">
            <div className="duolift-device-detail-card" style={{ width: "100%" }}>
                <div className="detail-card-header">
                    <h3 style={{ paddingTop: '10px' }}>ROUTE-CENTRIC DETAILS</h3>
                </div>
                <div style={{ padding: '15px 20px', backgroundColor: '#f5f5f5', borderBottom: '1px solid #ddd' }}>
                    <Autocomplete
                        options={filterOptions.routes || []}
                        value={filters.route || null}
                        onChange={handleRouteFilterChange}
                        getOptionLabel={(option) => option.label || ''}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        renderInput={(params) => <TextField {...params} label="Filter by Route" size="small" />}
                        sx={{ width: 250, backgroundColor: 'white' }}
                    />
                </div>
                <div className="duolift-device-detail-card-body">
                    <div style={{ height: '440px', width: '100%' }}>
                        <DataGrid
                            rows={filteredData}
                            columns={columns}
                            pageSize={50}
                            rowsPerPageOptions={[50]}
                            paginationMode="client"
                            getRowId={(row) => row.id}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    allRouteDetailsData: state.loadValidationDashboard.routeDetailsData,
    filters: state.loadValidationDashboard.filters,
    filterOptions: state.loadValidationDashboard.filterOptions
});

const mapDispatchToProps = (dispatch) => ({
    updateFilters: (filterType, value) => dispatch(Actions.UPDATE_LVD_FILTERS(filterType, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(RouteDetailsGridPanel);
